/**
 * FPR Draft system types
 *
 * Covers both the Randomised Teams and Snake Draft modes for the team_creation phase.
 * The snake-order helpers at the end serve every game type's snake draft.
 */
/**
 * Derive the current picker from draft state.
 */
export function getCurrentPicker(state) {
    const n = state.pickOrder.length;
    if (state.roundNumber % 2 === 1) {
        // Odd round: forward
        return state.pickOrder[state.positionInRound];
    }
    else {
        // Even round: reversed
        return state.pickOrder[n - 1 - state.positionInRound];
    }
}
/**
 * Advance to the next picker, incrementing round when a full round completes.
 */
export function advancePicker(state) {
    const n = state.pickOrder.length;
    const nextPosition = state.positionInRound + 1;
    if (nextPosition >= n) {
        return { ...state, roundNumber: state.roundNumber + 1, positionInRound: 0 };
    }
    return { ...state, positionInRound: nextPosition };
}
